import PaymentOptionsMetadataReducer from 'commons-vehicle/PaymentOptionsMetadata/reducers/paymentOptionsMetadataReducer.js';
import PaymentOptionsMetadataActions from 'commons-vehicle/PaymentOptionsMetadata/actions/paymentOptionsMetadataActions.js';
import PaymentOptionsMetadataModel from 'commons-vehicle/PaymentOptionsMetadata/models/PaymentOptionsMetadataModel.js';

export { PaymentOptionsMetadataActions, PaymentOptionsMetadataReducer, PaymentOptionsMetadataModel };

export default {
    PaymentOptionsMetadataActions,
    PaymentOptionsMetadataReducer,
    PaymentOptionsMetadataModel,
};
